import { ITourChip, ITourDetails, IToursJSON, IToursMissing, IXMLHttpConfig, TourType, TourTypeCode } from "../global/types";
import { XMLHttpConfig } from "../global/XMLHttpConfig";
import { HttpService } from "../services/HttpService";

declare var _gaq: any;

export class ToursSearchResults {

    private httpSvc: HttpService;
    private locationId: number;
    private locationName: string;
    private regions: string[] = [];
    private types: string[] = [];
    private headingTextArray = ["Tours", "Escorted Tours", "Cruise Holidays", "Self-drive Tours", "Private Tours"];
    private tourTypesDictionary = ["N", "E", "C", "D", "O"];
    private activeTourType: TourType;
    private activeTourLocation: string;
    private timeout: any;

    constructor() {
        this.httpSvc = new HttpService();
        this.getTourLocationIdAndName();

        this.activeTourType = TourType.NONE;
        this.activeTourLocation = this.locationName;

        this.getTours();
    }

    private getTourLocationIdAndName() {
        const tourIdEl: HTMLElement = document.querySelector("[data-tour-search-location-id]") as HTMLElement;
        const tourNameEl: HTMLElement = document.querySelector("[data-tour-search-location-name]") as HTMLElement;

        this.locationId = parseInt(tourIdEl.getAttribute("data-tour-search-location-id"), 10);
        this.locationName = tourNameEl.getAttribute("data-tour-search-location-name");
    }

    private async getTours() {
        this.toggleLoading(true);

        const response: IToursJSON | any = await this.httpSvc.get(new XMLHttpConfig(`/utility/tours/getToursByLocation.aspx?weblocationid=${this.locationId}`));

        this.toggleLoading(false);
        
        if (response.TourDetails && response.TourDetails.length > 0) {
            if (response.ToursMissing) {
                this.locationName = response.ToursMissing.NewLocation;
                this.missingTours(response.ToursMissing);
            }

            this.createFilters(response);
            this.populatePageWithTours(response);
            this.updateCounts();
        }
    }

    private missingTours(data: IToursMissing) {
        const container: HTMLElement = document.querySelector("[data-tours-missing]") as HTMLElement;
        const originalLocations: NodeListOf<HTMLElement> = document.querySelectorAll("[data-tours-missing-original]") as NodeListOf<HTMLElement>;
        const newLocations: NodeListOf<HTMLElement> = document.querySelectorAll("[data-tours-missing-new]") as NodeListOf<HTMLElement>;

        container.style.display = "block";

        for (let i = 0; i < originalLocations.length; i++) {
            originalLocations[i].innerText = data.OriginalLocation;
        }

        for (let i = 0; i < newLocations.length; i++) {
            newLocations[i].innerText = data.NewLocation;
        }

    }

    private createFilters(data: IToursJSON) {
        this.regions = [];
        this.types = [];

        this.regions.push(this.locationName);

        for (let i = 0; i < data.TourDetails.length; i++) {
            const tour = data.TourDetails[i];

            if (this.regions.indexOf(tour.MainLocation) === -1) {
                this.regions.push(tour.MainLocation);
            }
            if (this.types.indexOf(tour.Type) === -1) {
                this.types.push(tour.Type);
            }
        }    

        this.createTourTypeFilter();
        this.createHeading();  
    }

    private createTourTypeFilter() {
        if (this.types.length > 0) {
            const tourTypesContainer: HTMLElement = document.querySelector("[data-tour-search-type-filter]") as HTMLElement;
            const tourTypesList: HTMLElement = document.createElement("div") as HTMLElement;
            const defaultTourType: HTMLElement = document.createElement("a") as HTMLElement;

            defaultTourType.innerText = "All Tour Types";
            defaultTourType.setAttribute("href", "");
            defaultTourType.setAttribute("data-tour-type-filter", "N");
            defaultTourType.classList.add("pt-single");
            defaultTourType.classList.add("pb-single");
            defaultTourType.classList.add("pr-double");
            defaultTourType.classList.add("pl-double");
            defaultTourType.classList.add("inline-block");
            defaultTourType.classList.add("daf-white");

            defaultTourType.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleLoading(true);
                this.clearStage();
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.toggleLoading(false);
                    const index: number = this.tourTypesDictionary.indexOf(defaultTourType.getAttribute("data-tour-type-filter"));
                    this.activeTourType = this.assignTypeByIndex(index);
                    this.updateHeadingWithTourType();
                    this.updateCounts();
                    this.filterStage();
                    this.selectFirstOption();
                }, 300);
                _gaq.push(["_trackEvent", "Interaction", `Tour Location Page - Filter By Type (${this.activeTourLocation} for ${this.tourTypesDictionary[this.activeTourType]})`, document.URL, 0, false]);
            });

            tourTypesList.appendChild(defaultTourType);

            for (let i = 0; i < this.types.length; i++) {
                const tourType: HTMLElement = document.createElement("a") as HTMLElement;
                const index: number = this.tourTypesDictionary.indexOf(this.types[i]);

                tourType.innerText = this.headingTextArray[index];
                tourType.setAttribute("href", "");
                tourType.setAttribute("data-tour-type-filter", this.tourTypesDictionary[index]);
                tourType.classList.add("pt-single");
                tourType.classList.add("pb-single");
                tourType.classList.add("pr-double");
                tourType.classList.add("pl-double");
                tourType.classList.add("inline-block");
                tourType.classList.add("daf-white");

                tourType.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.toggleLoading(true);
                    this.clearStage();
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.toggleLoading(false);
                        const typeIndex: number = this.tourTypesDictionary.indexOf(tourType.getAttribute("data-tour-type-filter"));
                        this.activeTourType = this.assignTypeByIndex(typeIndex);
                        this.updateHeadingWithTourType();
                        this.updateCounts();
                        this.filterStage();
                        this.selectFirstOption();
                    }, 300);
                    _gaq.push(["_trackEvent", "Interaction", `Tour Location Page - Filter By Type (${this.activeTourLocation} for ${this.tourTypesDictionary[this.activeTourType]})`, document.URL, 0, false]);
                });

                tourTypesList.appendChild(tourType);
            }

            tourTypesList.classList.add("daf-gray-bg");
            tourTypesList.classList.add("daf-white");
            tourTypesList.classList.add("text-center");
            tourTypesList.classList.add("mb-quad");

            tourTypesContainer.appendChild(tourTypesList); 
        }
    }

    private createHeading() {
        const headingContainer: HTMLElement = document.querySelector("[data-tours-heading]") as HTMLElement;
        const heading: HTMLElement = document.createElement("h2") as HTMLElement;
        const headingText: HTMLElement = document.createElement("em") as HTMLElement;
        
        heading.classList.add("mt-single");
        heading.classList.add("mb-single");

        heading.appendChild(headingText);
        headingContainer.appendChild(heading);

        this.updateHeadingWithTourType();
        this.addSelectInputToHeading();
        this.bindSelectInputBehaviour();
    }

    private updateHeadingWithTourType() {
        const headingText: HTMLElement = document.querySelector("[data-tours-heading] em") as HTMLElement;
        const newText: string = this.headingTextArray[this.activeTourType];

        headingText.innerText = `${newText} INCLUDING `;
    }

    private addSelectInputToHeading() {
        const heading: HTMLElement = document.querySelector("[data-tours-heading] h2") as HTMLElement;
        const select: HTMLSelectElement = document.createElement("select") as HTMLSelectElement;

        for (let i = 0; i < this.regions.length; i++) {
            const option: HTMLElement = document.createElement("option") as HTMLElement;
            const countSpan: HTMLElement = document.createElement("span") as HTMLElement;

            option.innerText = ` ${this.regions[i]}`;
            option.setAttribute("value", this.regions[i]);

            countSpan.setAttribute("data-tour-count-for-region", this.regions[i]);

            option.appendChild(countSpan);
            select.appendChild(option);
        }

        heading.appendChild(select);
    }

    private updateCounts() {
        const countContainers: NodeListOf<HTMLElement> = document.querySelectorAll("[data-tours-heading] option") as NodeListOf<HTMLElement>; 
        const counts: NodeListOf<HTMLElement> = document.querySelectorAll("[data-tours-heading] span") as NodeListOf<HTMLElement>;
        for (let i = 0; i < counts.length; i++) {
            const region = counts[i].getAttribute("data-tour-count-for-region");
            let selector: string;
            let count: number;

            if (this.activeTourType === TourType.NONE) {
                if (region === this.locationName) {
                    selector = `[data-tour-location]`;
                } else {
                    selector = `[data-tour-location="${region}"]`;                   
                }

            } else {
                if (region === this.locationName) {
                    selector = `[data-tour-type="${this.tourTypesDictionary[this.activeTourType]}"]`;
                } else {
                    selector = `[data-tour-location="${region}"][data-tour-type="${this.tourTypesDictionary[this.activeTourType]}"]`;
                }               
            }

            count = document.querySelectorAll(selector).length;

            if (count > 0) {
                counts[i].innerText = `(${count})`;
                countContainers[i].style.display = "block";
            } else {
                countContainers[i].style.display = "none";
            }

        }
    }

    private bindSelectInputBehaviour() {
        const select: HTMLInputElement = document.querySelector("[data-tours-heading] select") as HTMLInputElement;

        select.addEventListener("change", () => {
            this.activeTourLocation = select.value;
            this.filterStage();
            _gaq.push(["_trackEvent", "Interaction", `Tour Location Page - Select Option ${this.activeTourLocation} for ${this.tourTypesDictionary[this.activeTourType]}`, document.URL, 0, false]);
        });
    }

    private filterStage() {
        const tours: NodeListOf<HTMLElement> = document.querySelectorAll("[data-tour]") as NodeListOf<HTMLElement>;

        for (let i = 0; i < tours.length; i++) {
            const tour = tours[i];

            const show = {
                location: false,
                type: false,
            };

            if (tour.getAttribute("data-tour-location") === this.activeTourLocation || this.activeTourLocation === this.locationName) {
                show.location = true;
            }

            if (tour.getAttribute("data-tour-type") === this.tourTypesDictionary[this.activeTourType] || this.activeTourType === TourType.NONE) {
                show.type = true;
            }

            tour.style.display = show.location && show.type ? "block" : "none";
        }
    }

    private populatePageWithTours(data: IToursJSON) {
        const stage: HTMLElement = document.querySelector("[data-tours-stage]") as HTMLElement;

        for (let i = 0; i < data.TourDetails.length; i++) {
            const tour = data.TourDetails[i];
            const container: HTMLElement = document.createElement("a");
            const header: HTMLElement = document.createElement("h4");
            const image: HTMLElement = document.createElement("img");
            const description: HTMLElement = document.createElement("p");
            const footer: HTMLElement = document.createElement("h5");

            header.innerText = tour.TourName;
            image.setAttribute("src", tour.TourImageURL);
            description.innerText = tour.DescriptionHeader;
            footer.innerHTML = `${tour.Days} days fr <strong>£${tour.Price}pp</strong>`;

            container.classList.add("tour-tour");
            container.classList.add("block");
            container.classList.add("col-xxs-12");
            container.classList.add("col-xs-6");
            container.classList.add("col-sm-4");
            container.setAttribute("href", tour.TourURL);
            container.setAttribute("data-tour", tour.TourId.toString());
            container.setAttribute("data-tour-type", tour.Type);
            container.setAttribute("data-tour-location", tour.MainLocation);

            container.appendChild(header);
            container.appendChild(image);
            container.appendChild(description);
            container.appendChild(footer);

            stage.appendChild(container);
        }
    }

    private selectFirstOption() {
        const select: HTMLSelectElement = document.querySelector("[data-tours-heading] select") as HTMLSelectElement;
        const event: Event = document.createEvent("HTMLEvents");
        event.initEvent("change", false, true);
        select.selectedIndex = 0;
        select.dispatchEvent(event);
    }

    private countToursLoaded(): number {
        const tours: NodeListOf<HTMLElement> = document.querySelectorAll("[data-tour]") as NodeListOf<HTMLElement>;

        return tours ? tours.length : 0;
    }

    private toggleLoading(status: boolean) {
        const placeholderTours: HTMLElement = document.querySelector("[data-tours-loading]") as HTMLElement;
        placeholderTours.style.display = status ? "block" : "none";
    }

    private clearStage() {
        const tours: NodeListOf<HTMLElement> = document.querySelectorAll("[data-tour]") as NodeListOf<HTMLElement>;
        for (let i = 0; i < tours.length; i++) {
            tours[i].style.display = "none";
        }
    }

    private assignTypeByIndex(index: number): TourType {
        switch (index) {
            case 1:
                return TourType.ESCORTED_TOURS;
            case 2:
                return TourType.CRUISE_HOLIDAYS;
            case 3:
                return TourType.SELFDRIVE_TOURS;
            case 4:
                return TourType.PRIVATE_TOURS;
            default:
                return TourType.NONE;
        }
    }
}



// WEBPACK FOOTER //
// ./src/tours/ToursSearchResults.ts